<template>
  <v-snackbar v-model="show" :color="color === 'success' ? '#2E7D32' : color">
    {{ message }}
    <template v-slot:actions>
      <v-btn variant="text" @click="show = false">Close</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: "",
      color: "",
    };
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      console.log(mutation.type, state);
      if (mutation.type === "showSnackbarMessage") {
        this.message = state.snackbar.content;
        this.color = state.snackbar.color ? state.snackbar.color : "success";
        this.show = true;
      }
    });
  },
};
</script>

<style>
/* Vuetify's success green (#4CAF50) gives white text only 2.8:1, so the
   snackbar uses a darker green (5.1:1) and the Close button stays fully
   opaque white. */
.v-snackbar .v-snackbar__actions .v-btn {
  color: #fff;
  opacity: 1;
}
</style>
